import { Model } from '@vuex-orm/core';
import DeliveryRegionAPI from '@/api/DeliveryRegionAPI';
import { SessionStorageService as ss } from '@/services/SessionStorageService';
import { DeliveryRegionFields } from '@/interfaces/DeliveryRegion';

export default class DeliveryRegion extends Model {
    public static entity = 'deliveryRegion';

    public id!: string;
    public name!: string;

    public static fields() {
        return {
            id: this.string(null),
            name: this.attr(null),
        };
    }

    public static async getAll() {
        let deliveryRegions;

        if (ss.has('deliveryRegions')) {
            deliveryRegions = ss.getAndParse('deliveryRegions');
        } else {
            try {
                const fetched = await DeliveryRegionAPI.getAll();
                deliveryRegions = fetched.data;
                ss.stringifyAndSave('deliveryRegions', deliveryRegions);
            } catch (e) {
                return Promise.reject(e);
            }
        }

        this.create({
            data: deliveryRegions,
        });

        return Promise.resolve();
    }

    public static async getById(deliveryRegionId: string) {
        let deliveryRegion;
        try {
            deliveryRegion = await DeliveryRegionAPI.getById(deliveryRegionId);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: deliveryRegion.data,
        });
        return Promise.resolve(deliveryRegion);
    }

    public static async updateExisting(deliveryRegionId: string, deliveryRegionInfo: DeliveryRegionFields) {
        let deliveryRegion;
        try {
            deliveryRegion = await DeliveryRegionAPI.update(deliveryRegionId, deliveryRegionInfo);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: deliveryRegion.data,
        });

        const deliveryRegions = ss.getAndParse('deliveryRegions') || [];
        const index = deliveryRegions.findIndex((dr: any) => dr.id === deliveryRegionId);
        if (index !== -1) {
            deliveryRegions[index] = deliveryRegion.data;
            ss.stringifyAndSave('deliveryRegions', deliveryRegions);
        }

        return Promise.resolve(deliveryRegion);
    }

    public static async createNew(deliveryRegionInfo: DeliveryRegionFields) {
        let deliveryRegion;
        try {
            deliveryRegion = await DeliveryRegionAPI.create(deliveryRegionInfo);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: deliveryRegion.data,
        });

        const deliveryRegions = ss.getAndParse('deliveryRegions') || [];
        deliveryRegions.push(deliveryRegion.data);
        ss.stringifyAndSave('deliveryRegions', deliveryRegions);

        return Promise.resolve(deliveryRegion);
    }

    public static async deleteExisting(deliveryRegionId: string) {
        try {
            await DeliveryRegionAPI.delete(deliveryRegionId);
        } catch (e) {
            return Promise.reject(e);
        }
        await DeliveryRegion.delete(deliveryRegionId);

        const deliveryRegions = ss.getAndParse('deliveryRegions') || [];
        const updated = deliveryRegions.filter((dr: any) => dr.id !== deliveryRegionId);
        ss.stringifyAndSave('deliveryRegions', updated);

        return Promise.resolve();
    }
}
